// Mock data for Aurie Cano's personal website

export const siteData = {
  name: "Aurie Cano",
  nickname: "La Chilerísima",
  tagline: "Actriz de doblaje, cantante, dramaturga y productora artística guatemalteca.",
  heroSubtitle: "Una artista que transforma historias en emociones, voces en vida y sueños en experiencias reales.",
};

export const aboutData = {
  fullName: "Aurie Alejandra Cano Flores",
  bio: "Es una artista multifacética que ha construido su trayectoria sólida en el mundo del teatro, música, comunicación, doblaje y producción artística.",
  extendedBio: "Ha participado en producciones de cine, series web y contenido animado, desarrollando personajes que conectan profundamente con el público. Además, su historia personal refleja resiliencia y evolución, convirtiéndose en una fuente de inspiración dentro y fuera del ámbito artístico.",
  roles: [
    "Actriz de doblaje",
    "Directora de doblaje",
    "Actriz de teatro",
    "Actriz de Cine",
    "Cantante y cantautora",
    "Locutora",
    "Presentadora de TV",
    "Dramaturga y titiritera",
    "Productora artística"
  ],
  image: "https://customer-assets.emergentagent.com/job_chilerisima-art/artifacts/ti0v3rw1_FB_IMG_1775077628592.jpg"
};

export const bookData = {
  title: "Soledad F451",
  subtitle: "Una obra de Aurie Cano",
  description: "Una obra de teatro que aborda la trata de personas con el objetivo de visibilizar y sensibilizar sobre esta problemática social.",
  extendedDescription: "Basada en investigaciones y testimonios, la obra busca la transformación social y cuenta con el apoyo de ADESCA. El texto busca fomentar la denuncia y sensibilizar a la población, incluyendo información importante en sus separadores.",
  image: "https://customer-assets.emergentagent.com/job_chilerisima-art/artifacts/m818kgjt_WhatsApp%20Image%202026-04-02%20at%2001.26.38.jpeg",
  details: [
    { label: "Temática", value: "Trata de personas, abordando el impacto en las víctimas y sus familias" },
    { label: "Formato", value: "Dramaturgia (obra de teatro)" },
    { label: "Lanzamiento", value: "Presentado en 2024, con eventos en la Biblioteca Nacional Luis Cardoza y Aragón y La Teca" },
    { label: "Colaboraciones", value: "Trabajo conjunto con Coloquia Mujeres y apoyo de ADESCA" },
    { label: "Adquisición", value: "Disponible en editorial Chosamag y Rayuela" }
  ]
};

export const experienceData = {
  studio: "Karu Dubs & Recordings",
  description: "Su capacidad interpretativa le permite adaptarse a distintos registros, estilos y emociones, aportando autenticidad a cada proyecto.",
  studioImage: "https://customer-assets.emergentagent.com/job_chilerisima-art/artifacts/tf496kke_Screenshot_20260401_171710_TikTok.jpg",
  categories: [
    {
      title: "Películas",
      icon: "Film",
      items: [
        "La desaparición de Sidney Hall",
        "El monstruo del armario",
        "Kaahani"
      ]
    },
    {
      title: "Series Web",
      icon: "Tv",
      items: [
        "El Rey Cucaracha"
      ]
    },
    {
      title: "Cortos Animados",
      icon: "Clapperboard",
      items: [
        "El palacio mental de Hugo"
      ]
    }
  ]
};

export const projectsData = [
  {
    id: 1,
    title: "Sirenas de Guatemala",
    subtitle: "Comunidad única en el país",
    description: "Aurie lidera una comunidad única en el país, promoviendo el sirenismo como experiencia artística y vivencial.",
    details: [
      "Instructora certificada internacional",
      "Experiencias inmersivas sin necesidad de experiencia previa",
      "Desarrollo de comunidad de sirenas y tritones"
    ],
    tagline: "Un proyecto que mezcla arte, expresión corporal y conexión emocional.",
    image: "https://customer-assets.emergentagent.com/job_chilerisima-art/artifacts/c45wezin_Screenshot_20260401_150734_Facebook.jpg",
    gallery: [
      "https://customer-assets.emergentagent.com/job_chilerisima-art/artifacts/c45wezin_Screenshot_20260401_150734_Facebook.jpg",
      "https://customer-assets.emergentagent.com/job_chilerisima-art/artifacts/qn9ri3qr_90c55567bd5c542ffa2bba88881e9f78.png",
      "https://customer-assets.emergentagent.com/job_chilerisima-art/artifacts/xtkqnte0_71b15e879a0774f55e959028b5bff8eb.png"
    ],
    video: "https://customer-assets.emergentagent.com/job_chilerisima-art/artifacts/up44940r_VID_20260401_141054_823.mp4",
    color: "teal"
  },
  {
    id: 2,
    title: "Selenazo",
    subtitle: "Tributo a Selena",
    description: "Un espectáculo artístico que rinde homenaje a Selena, combinando música, interpretación y presencia escénica.",
    details: [
      "Interpretación de sus grandes éxitos",
      "Show en vivo con banda",
      "Homenaje lleno de pasión y energía"
    ],
    tagline: "Reviviendo la magia de Selena en cada escenario.",
    image: "https://customer-assets.emergentagent.com/job_chilerisima-art/artifacts/o4x1sgba_file_00000000289471f8ab9c59bee28b6173.png",
    color: "cyan"
  },
  {
    id: 3,
    title: "Radio Chilerísima",
    subtitle: "TikTok Live",
    description: "Aurie cuenta con un espacio en TikTok en vivo de lunes a viernes de 10:30 a 12:30, donde conecta directamente con su audiencia.",
    details: [
      "Interacción en tiempo real con espectadores",
      "Temas cómicos, serios y reflexivos",
      "Cada programa es único",
      "Dinámica final: el ganador del top de taps recibe la \"Sirena de Oro\""
    ],
    tagline: "Entretenimiento en vivo, directo al corazón.",
    image: "https://customer-assets.emergentagent.com/job_chilerisima-art/artifacts/pru9z6s1_Screenshot_20260401_171803_TikTok.jpg",
    color: "emerald"
  }
];

export const valueProposition = {
  intro: "Aurie no solo interpreta personajes.",
  highlight: "Crea experiencias.",
  description: "Su trabajo se basa en:",
  values: [
    { title: "Conexión emocional real", icon: "Heart" },
    { title: "Versatilidad artística", icon: "Palette" },
    { title: "Profesionalismo en cada producción", icon: "Award" },
    { title: "Capacidad de adaptación a distintos formatos", icon: "Layers" }
  ]
};

export const servicesData = [
  {
    title: "Doblaje profesional",
    description: "Voces que dan vida a personajes con autenticidad y emoción.",
    icon: "Mic"
  },
  {
    title: "Locución comercial e institucional",
    description: "Voz profesional para spots, corporativos y más.",
    icon: "Radio"
  },
  {
    title: "Producción artística y dirección",
    description: "Dirección creativa de proyectos audiovisuales y escénicos.",
    icon: "Clapperboard"
  },
  {
    title: "Presentaciones en vivo / shows",
    description: "Espectáculos únicos llenos de energía y conexión.",
    icon: "Music"
  },
  {
    title: "Talleres de sirenismo",
    description: "Puedes vivir la experiencia de convertirte en una Sirena o un Tritón.",
    icon: "Waves"
  },
  {
    title: "Proyectos musicales y tributos",
    description: "Creación y producción de tributos musicales en vivo.",
    icon: "AudioLines"
  }
];

export const contactData = {
  whatsapp: "+502 46413419",
  whatsappLink: "https://wa.me/50246413419",
  email: "auriecano@gmail.com",
  instagram: "https://www.instagram.com/auriecano?igsh=ZmlxN2I1YzhwNWRm",
  instagramHandle: "@auriecano",
  tiktok: "https://www.tiktok.com/@auriecano?_r=1&_t=ZN-95BWpywZUWM",
  tiktokHandle: "@auriecano"
};

export const closingData = {
  quote: "No se trata solo de talento. Se trata de lo que una voz, una historia o una experiencia puede hacer sentir.",
  closing: "Aurie Cano convierte cada proyecto en algo inolvidable.",
  cta: "Para contrataciones, colaboraciones o conocer más sobre su trabajo artístico:"
};

export const navLinks = [
  { label: "Inicio", href: "#hero" },
  { label: "Sobre mí", href: "#about" },
  { label: "Experiencia", href: "#experience" },
  { label: "Proyectos", href: "#projects" },
  { label: "Servicios", href: "#services" },
  { label: "Contacto", href: "#contact" }
];
